<script lang="ts">
import { defineComponent } from 'vue'
export default defineComponent({
  name: 'AddNewTag',
})
</script>
<template>
  <span class="AddNewTag">
    <a-tag closable @close="onCloseTag(t)" v-for="t in tags" :key="t" :class="size">{{t}}</a-tag>
    <a-input
      v-if="tagInputVisible"
      ref="tagInputDomRef"
      type="text"
      :class="size+'Ipt'"
      :value="tagInputValue"
      @change="handleInputChange"
      @blur="handleTagInputConfirm"
      @keyup.enter="handleTagInputConfirm"
    />
    <a-tag v-if="!tagInputVisible&&tagAddVisible" @click="showTagInput" :class="[size,'addTag']">
      <PlusOutlined/>
    </a-tag>
  </span>
</template>

<script lang="ts" setup name="AddNewTag">
import { ref, reactive, nextTick, onMounted,defineModel,defineProps
  ,defineEmits
  } from 'vue'
import { pull } from 'lodash-es'
import { PlusOutlined } from '@ant-design/icons-vue'

const props=defineProps({
    max: {
      type: Number,
      default: 5
    },
    type: {
      type: String,
      default:''
    },
    value: {
      type: Array,
    },
    size: {
      type: String,
      default: 'small'
    }
  })
const emit=defineEmits(['update:value'])
const tags = ref<Array>([])
 onMounted(() => {
    if(props.value&&props.value.length>0){
        tags.value=props.value
    }
    if (tags.value.length >= props.max) {
        tagAddVisible.value = false
    }
  })

    // 点击新增标签
    const tagInputVisible = ref(false)
    const tagInputDomRef = ref(null)
    const showTagInput = () => {
      tagInputVisible.value = true
      nextTick(() => {
        tagInputDomRef.value.focus()
      })
    }

    // 输入内容
    const tagInputValue = ref('')
    const handleInputChange = (e:Event) => {
      tagInputValue.value = e.target.value
    }

    // 保存数据
    const tagAddVisible = ref(true)
    const emitData=():void=>{
        emit('update:value',tags.value)
    }
    const handleTagInputConfirm = ():Event => {
      const inputValue = tagInputValue.value
      let inputedTags = tags.value
      if (inputValue && !inputedTags.includes(inputValue)) {
        inputedTags = [...inputedTags, inputValue]
      }

      tags.value = inputedTags
      if (tags.value.length >= props.max) {
        tagAddVisible.value = false
      }
      tagInputVisible.value = false
      tagInputValue.value = ''
      emitData()
    }

    // 删除标签
    const onCloseTag = (name):Event => {
      tags.value = pull(tags.value, name)
      if (tags.value.length < props.max) {
        tagAddVisible.value = true
      }
      emitData()
    }
</script>

<style lang="less">
.AddNewTag {
  .addTag {
    background: #fff;
    border-style: dashed;
    cursor: pointer;
  }
  .middle {
    height: 30px;
    line-height: 28px;
    font-size: 15px;
  }
  .smallIpt {
    width: 78px;
    height: 20px;
  }
  .middleIpt {
    width: 90px;
    height: 30px;
  }
}
.darkMode {
  .AddNewTag {
    .addTag {
      background-color: rgba(0, 0, 0, 0.5);
    }
  }
}
</style>
